export enum TabType {
    DESCRIPTION = 'description',
    SPECIFICATION = 'specification',
    REVIEWS = 'reviews',
    WARRANTY = 'guaranty',
    TECHNICAL_DOCUMENTATION = 'technical_documentation',
    BUNDLE_INCLUDES = 'bundle-includes'
}

export default function Navigation({selected, setSelected, hideTabs = []}: {
    selected: TabType,
    setSelected: (selected: TabType) => void,
    hideTabs?: TabType[]
}) {

    const tabNames = {
        [TabType.DESCRIPTION]: 'Описание',
        [TabType.SPECIFICATION]: 'Характеристики',
        [TabType.REVIEWS]: 'Отзывы',
        [TabType.WARRANTY]: 'Гарантия',
        [TabType.TECHNICAL_DOCUMENTATION]: 'Тех. документация',
        [TabType.BUNDLE_INCLUDES]: 'Комплектации'
    }

    const tabs = [TabType.DESCRIPTION, TabType.SPECIFICATION, TabType.WARRANTY, TabType.TECHNICAL_DOCUMENTATION, TabType.BUNDLE_INCLUDES]
        .filter(tab => !hideTabs.includes(tab));

    return (<ul className="nav-tabs product__nav-tabs" id="prodTab" role="tablist">
        {tabs.map((tab) => (
        <li className="nav-item"  key={tab}>
            <a className={selected === tab ? 'active' : ''}
               href={`/`}
               onClick={(event) => {
                   event.preventDefault()
                   setSelected(tab)
               }}>
                {tabNames[tab]}
            </a>
        </li>
        ))}
    </ul>)
}